import type { UserInformationService } from '../application';
import { makeContext } from './makeContext';

export const {
  Provider: UserInformationServiceProvider,
  useContext: useUserInformationService,
} = makeContext<UserInformationService>('UserInformationService');
